import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { UserUsageBarComponent } from './user-usage-bar.component';

@NgModule({
  declarations: [
    UserUsageBarComponent
  ],
  imports: [
    CommonModule,
    MatProgressBarModule
  ],
  exports: [
    UserUsageBarComponent
  ]
})
export class UserUsageBarModule { }
